// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"182":"c0629d26","205":"9006dd90","326":"d7c28553","339":"f6a92370","403":"7c338c36","484":"99dd0b0c","498":"a894522a","508":"8210cccd","551":"a9310a07","611":"190ade55","616":"377288c5","629":"4c68ce89","640":"cfa324e2","740":"474f3fde","974":"abd5e7a4"}[chunkId] + ".chunk.js";
};